"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const react_1 = __importDefault(require("react"));
const prop_types_1 = require("prop-types");
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
function ButtonGroup(_ref) {
  let {
    categories,
    onButtonClick
  } = _ref;
  if (categories.length === 0) {
    return null;
  }
  return react_1.default.createElement("div", {
    className: styles_module_css_1.default['button-group-container']
  }, react_1.default.createElement("span", {
    className: styles_module_css_1.default['button-group-description']
  }, "Tap button for category breakdown"), react_1.default.createElement("div", {
    className: styles_module_css_1.default['button-wrapper']
  }, categories.map(_ref2 => {
    let {
      id: category,
      label,
      color,
      selected
    } = _ref2;
    return react_1.default.createElement("div", {
      key: category,
      className: styles_module_css_1.default['category-button'],
      style: {
        color: `${selected ? 'white' : color}`,
        backgroundColor: `${selected ? color : 'white'}`,
        borderColor: `${selected ? color : '#BDBDBD'}`
      },
      onClick: () => onButtonClick(category),
      "aria-hidden": "true"
    }, label);
  })));
}
ButtonGroup.propTypes = {
  /*
   * Color and text for each Button
   */
  categories: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    id: prop_types_1.string.isRequired,
    label: prop_types_1.string.isRequired,
    color: prop_types_1.string.isRequired,
    selected: prop_types_1.bool
  }).isRequired).isRequired,
  /*
   * Function to call when a button is clicked.
   * Function is called with the `id` of the button from the categories property as it's only parameter.
   */
  onButtonClick: prop_types_1.func.isRequired
};
exports.default = ButtonGroup;